import { render, staticRenderFns } from "./AppSumoForm.vue?vue&type=template&id=a54e7ba8&scoped=true"
import script from "./AppSumoForm.vue?vue&type=script&lang=js"
export * from "./AppSumoForm.vue?vue&type=script&lang=js"
import style0 from "./AppSumoForm.vue?vue&type=style&index=0&id=a54e7ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54e7ba8",
  null
  
)

export default component.exports